import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}const n=(e,t)=>e.findIndex(t);export{t as findIndex};
//# sourceMappingURL=findIndex-Cn-qCBWN.js.map